import { render, staticRenderFns } from "./Genitores.vue?vue&type=template&id=776d16de&scoped=true&"
import script from "./Genitores.vue?vue&type=script&lang=js&"
export * from "./Genitores.vue?vue&type=script&lang=js&"
import style0 from "./Genitores.vue?vue&type=style&index=0&id=776d16de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d16de",
  null
  
)

export default component.exports